import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import adminService from '../../services/adminService';
import { loginStart, loginSuccess, loginFailure } from '../../redux/slices/adminSlice';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.admin);
  
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loginStart());

    try {
      const response = await adminService.login(credentials);
      const { token, admin } = response.data;
      
      // Store the token
      localStorage.setItem('adminToken', token);
      
      // Set the token in the API headers
      adminService.setAuthToken(token);
      
      // Update Redux state
      dispatch(loginSuccess({ token, admin }));
      
      // Redirect to dashboard
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      dispatch(loginFailure(
        error.response?.data?.message || 'Invalid email or password'
      ));
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4 },
            width: '100%',
            maxWidth: 480,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 700 }}>
            Admin Login
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 2.5 }}>
            Sign in to manage users, subscriptions, and verification workflows.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={credentials.email}
              onChange={handleChange}
              margin="normal"
              required
              autoComplete="email"
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={credentials.password}
              onChange={handleChange}
              margin="normal"
              required
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3, py: 1.3 }}
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 